export default function postPriceReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'CREATE_PRICE_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'CREATE_PRICE_ERROR':
      return {...state, ...{error: action.error}};

    case 'CREATE_PRICE_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}